import React from 'react';
import cx from 'classnames';
import ThemeProvider from 'threads5/themes/theme-provider';

import { Column, Stack } from 'src/components-v2/Layout';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { Wrapper, RichTextSwitch } from 'src/containers';
import { useCmsMode } from 'src/contexts/ModeContext/ModeContext';
import { useComponentTheme } from 'src/hooks/useComponentTheme';

import styles from './RichTextHighlightsSection.module.scss';

export const RichTextHighlightsSection = ({ fields, sys }) => {
  const inspectorProps = useContentfulInspectorMode({
    entryId: sys?.id,
  });
  const mode = useCmsMode({
    mode: fields?.mode,
    backgroundColor: fields?.backgroundColor,
  });
  const componentTheme = useComponentTheme(mode);
  const background =
    componentTheme.palette[fields?.backgroundColor] ||
    fields?.backgroundColor?.toLowerCase() ||
    'transparent';

  return (
    <ThemeProvider theme={componentTheme}>
      <Wrapper
        component='section'
        {...inspectorProps({ fieldId: 'internalTitle' })}
        sx={{
          background,
        }}
        className={cx(styles.RichTextHighlightsSection)}
      >
        <Column
          xsOffset={1}
          xs={22}
          smOffset={3}
          sm={18}
          mdOffset={5}
          md={14}
          lgOffset={2}
          lg={4}
          xlOffset={2}
          xl={4}
          xxlOffset={2}
          xxl={4}
          className={cx(styles.HighlightsWrapper)}
        >
          {fields?.highlightsSidebar && (
            <Stack
              component='aside'
              className={cx(styles.Highlights)}
              direction='column'
              gap={2}
              sx={{
                '& .cms-btn-primary': {
                  justifyContent: 'center',
                },
              }}
            >
              <RichTextSwitch
                sys={sys}
                content={fields?.highlightsSidebar}
                nodes={{
                  h3: {
                    variant: 'p2',
                    component: 'h3',
                    fieldId: 'body',
                  },
                  h6: {
                    variant: 'h6',
                    component: 'h6',
                    fieldId: 'body',
                  },
                  p: {
                    variant: 'p3',
                    component: 'p',
                    fieldId: 'body',
                  },
                }}
              />
            </Stack>
          )}
        </Column>
        <Column
          xsOffset={1}
          xs={22}
          smOffset={3}
          sm={18}
          mdOffset={5}
          md={14}
          lgOffset={0}
          lg={12}
          xlOffset={1}
          xl={10}
          xxlOffset={1}
          xxl={10}
          className={cx(styles.Body)}
        >
          <Stack
            gap={3.75}
            sx={{
              mt: { xs: '0px', lg: '-10px' },
              '& .cms-btn-primary, & .cms-btn-secondary': {
                alignSelf: 'flex-start',
              },
            }}
          >
            <RichTextSwitch
              sys={sys}
              content={fields?.body}
              nodes={{
                h2: {
                  variant: 'h3',
                  component: 'h2',
                  fieldId: 'body',
                },
                h3: {
                  variant: 'h4',
                  component: 'h3',
                  fieldId: 'body',
                },
                p: {
                  variant: 'p4',
                  component: 'p',
                  fieldId: 'body',
                },
              }}
            />
          </Stack>
        </Column>
      </Wrapper>
    </ThemeProvider>
  );
};
